<template>
  <div v-drag>
    <a-modal  
             v-model:visible="dialogVisible"
             :maskClosable='false'
             width="720px"
             @cancel="back"
             :closable="false"
              wrap-class-name="my-exam-modal"
             :footer="null"
             cancelText="取消"
             okText="开始答题"
             @ok="handleClose">
              <template #title>
      <span style="font-size: 24rem;font-weight: 600">答题说明</span>
    </template>
      <div class="text_warp">
          <p> 1.本系统支持提前设置做卷时间，请在考试开始前完成设置，系统将在规定时间内自动提交。</p>
        <p>2.选择题请点击选项方框，系统自动保存。</p>
        <p>3.多选题、填空题和解答题请在自备纸张上填写题号和相应答案，确保字迹清晰、区域对应。</p>
        <p>4.完成试卷后进入答题卡页面，拍摄答案照片(最多只能上传6张照片，每张照片不超过10M)，检查清晰度和完整性后上传。</p>
           <p>5.确认无误后，点击提交答案；提交后不可修改，请谨慎操作。</p>
      </div>
            <div class="text_warp1">
        <p style="text-align: center;font-weight: 600;font-size: 24rem;">批改设置 </p>
      
        <div   style="display: flex;margin-left: 10rem;font-size: 22rem;align-items: center; margin-bottom: 39rem;">
          <div style="margin-right: 150rem;">将试卷设置为自评</div>
          <div style="margin-top: 4rem;"> 
         
  <a-checkbox
    :checked="is_self_evaluation === true"
    @change="onYes1">
    是
  </a-checkbox>

   
  <a-checkbox
  style="margin-left: 100rem;"
    :checked="is_self_evaluation === false"
    @change="onNo1">
    否
  </a-checkbox>

             </div>
        </div>
      
      </div>
            <div class="text_warp1">
        <p style="text-align: center;font-weight: 600;font-size: 24rem;">做卷时间 </p>
        <div v-if="$route.query.form&&JSON.parse( $route.query.form).paper_duration>0" style="display: flex;justify-content: center;font-weight: 400;
font-size: 24rem; margin-bottom: 39rem; ">
          <div > 请在
   <span style="margin: 0 10rem;">{{ hours }}</span> 小时 <span style="margin: 0 10rem;"> {{ mins }}</span> 分钟
  内完成答题</div>
        
        </div>
        <div v-else style="display: flex;margin-left: 10rem;font-size: 22rem;align-items: center; margin-bottom: 39rem;">
          <div style="margin-right: 150rem;">是否设置做卷时间</div>
          <div style="margin-top: 4rem;"> 
         
  <a-checkbox
    :checked="val === true"
    @change="onYes">
    是
  </a-checkbox>

  <!-- 否 -->
  <a-checkbox
  style="margin-left: 100rem;"
    :checked="val === false"
    @change="onNo">
    否
  </a-checkbox>

             </div>
        </div>
        <p v-if="val "
           style="margin-top: 28rem ;display: flex; justify-content: flex-end; gap: 24px;margin-right: 40rem;font-size: 22rem;align-items: center; ">
          <a-input v-model:value="examTime"
                    placeholder=""
                    style="width: 10%;"
                    @change="changeTime" />
          小时
          <a-input v-model:value="examTime1"
                    placeholder=""
                    style="width: 10%;"
                    @change="changeTime" />
          分钟
        </p>
      </div>
           <div class="text_warp1" v-if="$route.query.isWrong&&$route.query.isWrong==1">
        <p style="text-align: center;font-weight: 600;font-size: 24rem;">推送设置 </p>
      
        <div   style="display: flex;margin-left: 10rem;font-size: 22rem;align-items: center; margin-bottom: 39rem;">
          <div style="margin-right: 118rem;">设置导出题目类型     <a-tooltip>
    <template #title>选择“是”，每个错题会推送5道相似题。选择“否”，试卷仅有原题。</template>
      <question-circle-outlined />
  </a-tooltip></div>
          <div style="margin-top: 4rem;"> 
         
  <a-checkbox
    :checked="is_other_question === true"
    @change="onYes2">
    原题
  </a-checkbox>

   
  <a-checkbox
  style="margin-left: 77rem;"
    :checked="is_other_question === false"
    @change="onNo2">
    原题加推送题
  </a-checkbox>

             </div>
        </div>
      
      </div>
       <div class="btn_groups">
        <div class="btn"
             @click="back">
          取消
        </div>

        <div class="btn1"
             @click="handleClose">
          开始答题
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from "vue-router"
import { reactive, ref } from '@vue/reactivity';
import { computed } from 'vue'
import { QuestionCircleOutlined } from '@ant-design/icons-vue'

const route = useRoute()

/* 解析 paper_duration（分钟） */
const duration = computed(() => {
  try {
    return Number(JSON.parse(route.query.form || '{}').paper_duration || 0)
  } catch {
    return 0
  }
})
 

const hours = computed(() => Math.floor(duration.value / 60))
const mins  = computed(() => duration.value % 60)
const { dialogVisible } = defineProps({
  dialogVisible: {
    type: Boolean,
    default: false
  }
})
let isCollapse = computed(() => store.home.state.isCollapse);
const emit = defineEmits(['expalinSubmitDapaper'])
const router = useRouter()
let checked = ref(true)
const examTime1 = ref(null)
const examTime = ref(null)
const handleClose = () => {
  emit("expalinSubmitDapaper")
}
 const  changeTime= ()=> {
      let time =  examTime.value * 3600 +  examTime1.value * 60
      window.localStorage.setItem('exam_time_left', time)
    }
const val = ref(false)        
const is_self_evaluation = ref(false)
const is_other_question = ref(false)
//  const 箭头函数写法
const onYes = (e) => {
  val.value = e.target.checked ? true : null
}

const onNo = (e) => {
  val.value = e.target.checked ? false : null
  if(val.value){
      window.localStorage.clear('exam_time_left')
  }

}
const onYes1 = (e) => {
  is_self_evaluation.value = e.target.checked ? true : null
}
const onYes2 = (e) => {
  is_other_question.value = e.target.checked ? true : null
}
 
const onNo1 = (e) => {
  is_self_evaluation.value = e.target.checked ? false : null
  // if(val.value){
  //     window.localStorage.clear('exam_time_left')
  // }

  
}
const onNo2 = (e) => {
  is_other_question.value = e.target.checked ? false : null
}
 

const back = () => {
  router.go(-1)
}
defineExpose({
  is_self_evaluation,
  is_other_question
})
</script>

<style lang="scss" scoped>
 
 
.btn_groups {
  display: flex;
  border-top: 1px solid var(--neutral-color-eeeeee, #eee);
  height: 70px;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1 0 0;
    align-self: stretch;
    color: var(--light-333333, var(--neutral-color-333333, #333));
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px; /* 150% */
    border-right: 1px solid var(--neutral-color-eeeeee, #eee);
  }
  .btn1 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1 0 0;
    align-self: stretch;
    color: var(--light-333333, var(--neutral-color-333333, #2196f3));
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px; /* 150% */
  }
}
 ::v-deep  .ant-checkbox + span{
  font-size: 22rem;
 }
  .ant-modal-title{
  font-size:24rem
}
 ::v-deep  .ant-checkbox-inner{
  width: 24rem;
  height: 24rem;
}
.text_warp1{
margin-bottom: 29rem;
 
}
.text_warp {
  word-break: break-all;
  font-weight: 400;
  color: #333 !important;
  line-height: 36px;
  font-size: 22px;
  padding: 8px;
  padding-top: 0;
  p{
    margin-bottom: 0rem;
  }
}
.btn_warp {
  height: 50px;
  border-top: 1px solid #e5e5e5;
  display: flex;
  div {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    &:nth-child(1) {
      font-size: 18px;
      font-weight: bold;
      color: #999999;
      border-right: 1px solid #e5e5e5;
    }
    &:nth-child(2) {
      font-size: 18px;
      font-weight: bold;
      color: #2196f3;
    }
  }
}
::v-deep .el-dialog__body {
  padding: 0;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  display: none;
}
::v-deep .el-dialog__header {
  font-size: 18px;
  font-weight: 500;
  color: #333333;
  text-align: center;
}
::v-deep .el-dialog__title {
  color: #333333;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
}
::v-deep .el-dialog {
  border-radius: 10px;
  position: absolute;
  margin-left: 50%;
  transform: translateX(-50%);
}
</style>